export default __webpack_public_path__ + "static/media/logo_blablacar.b84a6e48.svg";